import {
  LOADING_CANVA,
  WAITING_DATA_CANVA,
  BAR_HIDDEN_CANVA,
  IS_SIDEBAR_HOME_CANVA,
  IS_VISITA_MAP_CANVA,
  SHOWED_MAP_CANVA,
  SELECTED_TORRE_CANVA,
  SELECTED_APTO_TIPO_CANVA,
  INDEX_APTO_TIPO_CANVA,
  TIPOS_APTOS_COTIZADOS_CANVA,
  SELECTED_APTOS_CANVA,
  SELECTED_FLOOR_CANVA,
  APTO_TIPO_OPENED_CANVA,
  OPEN_GALERIA_CANVA,
  OPEN_360_CANVA,
  SELECTED_POI_CANVA,
  IS_FORM_COTIZACION_CANVA,

  LINKS_CANVA,
  LINK_TRANSITION_CANVA,
  IS_TRANCITION_CANVA,
  INIT_FRAME_POI_CANVA,
  IS_PRE_TRANSITION_CANVA,

  APTOS_COTIZADOS_CANVA,

  IS_180_CANVA,
  SHOW_GENERAL_VIEW_CANVA,
  IS_IMAGE_360_CANVA,
  SHOW_BUBBLES_CANVA,
  SHOW_BILLBOARDS_CANVA,

  CATEGORY_FILTER_CANVA,
  TORRE_FILTER_CANVA,
  APTO_FILTER_CANVA,
  AMENITY_CANAVA,
  SHOWING_TORRES_SPIN_CANVA,
  TOWER_TRANSITION_CANVA,

  ROTATE_FOR_BUBBLE_CANVA,

  SELECTED_ZONA_INTERES_CANVA,
} from '../actions';

export const loadingCanva = (payload) => ({
  type: LOADING_CANVA,
  payload: payload
});
export const waitingCanva = (payload) => ({
  type: WAITING_DATA_CANVA,
  payload: payload
});
export const barHiddenCanva = (payload) => ({
  type: BAR_HIDDEN_CANVA,
  payload: payload
});
export const isSideBarHomeCanva = (payload) => ({
  type: IS_SIDEBAR_HOME_CANVA,
  payload: payload
});
export const isVisitaMapCanva = (payload) => ({
  type: IS_VISITA_MAP_CANVA,
  payload: payload
});
export const showedMapCanva = (payload) => ({
  type: SHOWED_MAP_CANVA,
  payload: payload
});
export const selectedTorreCanva = (payload) => ({
  type: SELECTED_TORRE_CANVA,
  payload: payload
});
export const selectedAptoTipoCanva = (payload) => ({
  type: SELECTED_APTO_TIPO_CANVA,
  payload: payload
});
export const indexAptoTipoCanva = (payload) => ({
  type: INDEX_APTO_TIPO_CANVA,
  payload: payload
});
export const tiposAptosCotizadosCanva = (payload) => ({
  type: TIPOS_APTOS_COTIZADOS_CANVA,
  payload: payload
});
export const selectedAptoCanva = (payload) => ({
  type: SELECTED_APTOS_CANVA,
  payload: payload
});
export const selectedFloorCanva = (payload) => ({
  type: SELECTED_FLOOR_CANVA,
  payload: payload
});
export const aptotipoOpenedCanva = (payload) => ({
  type: APTO_TIPO_OPENED_CANVA,
  payload: payload
});
export const openGaleriaCanva = (payload) => ({
  type: OPEN_GALERIA_CANVA,
  payload: payload
});
export const open360Canva = (payload) => ({
  type: OPEN_360_CANVA,
  payload: payload
});
export const selectedPOICanva = (payload) => ({
  type: SELECTED_POI_CANVA,
  payload: payload
});
export const isFormCotizacionCanva = (payload) => ({
  type: IS_FORM_COTIZACION_CANVA,
  payload: payload
});
export const linksCanva = (payload) => ({
  type: LINKS_CANVA,
  payload: payload
});
export const linkTransitionCanva = (payload) => ({
  type: LINK_TRANSITION_CANVA,
  payload: payload
});
export const isTransicionCanva = (payload) => ({
  type: IS_TRANCITION_CANVA,
  payload: payload
});
export const initFramePOICanva = (payload) => ({
  type: INIT_FRAME_POI_CANVA,
  payload: payload
});
export const isPreTransitionCanva = (payload) => ({
  type: IS_PRE_TRANSITION_CANVA,
  payload: payload
});
export const aptosCotizadosCanva = (payload) => ({
  type: APTOS_COTIZADOS_CANVA,
  payload: payload
});
export const is180Canva = (payload) => ({
  type: IS_180_CANVA,
  payload: payload
});
export const showGeneralViewCanva = (payload) => ({
  type: SHOW_GENERAL_VIEW_CANVA,
  payload: payload
});
export const isImage360Canva = (payload) => ({
  type: IS_IMAGE_360_CANVA,
  payload: payload
});
export const showBubblesCanva = (payload) => ({
  type: SHOW_BUBBLES_CANVA,
  payload: payload
});
export const showBillboardsCanva = (payload) => ({
  type: SHOW_BILLBOARDS_CANVA,
  payload: payload
});
export const categoryFilterCanva = (payload) => ({
  type: CATEGORY_FILTER_CANVA,
  payload: payload
});
export const torreFilterCanva = (payload) => ({
  type: TORRE_FILTER_CANVA,
  payload: payload
});
export const aptoFilterCanva = (payload) => ({
  type: APTO_FILTER_CANVA,
  payload: payload
});
export const amenityCanva = (payload) => ({
  type: AMENITY_CANAVA,
  payload: payload
});
export const showingTorresSpinCanva = (payload) => ({
  type: SHOWING_TORRES_SPIN_CANVA,
  payload: payload
});
export const towerTransitionCanva = (payload) => ({
  type: TOWER_TRANSITION_CANVA,
  payload: payload
});
export const rotateForBubbleCanva = (payload) => ({
  type: ROTATE_FOR_BUBBLE_CANVA,
  payload: payload
});
export const selectedZonaInteresCanva = (payload) => ({
  type: SELECTED_ZONA_INTERES_CANVA,
  payload: payload
});

